import { render, staticRenderFns } from "./sysModulePreview.vue?vue&type=template&id=0221f218&scoped=true&"
import script from "./sysModulePreview.vue?vue&type=script&lang=js&"
export * from "./sysModulePreview.vue?vue&type=script&lang=js&"
import style0 from "./sysModulePreview.vue?vue&type=style&index=0&id=0221f218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221f218",
  null
  
)

export default component.exports